import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

class LoginForm extends Component {
  render () {
    const onSubmit = this.props.onSubmit
    const onChange = this.props.onChange
    const user = this.props.user
    const idSave = this.props.idSave
    const toggleChecked = this.props.toggleChecked
    const redirect = this.props.redirect

    return (
      <div>
        <h1>로그인</h1>
        <form action="/" onSubmit={onSubmit}>
          <div className="input_wrap">
            <label htmlFor="username">이메일</label>
            <input id="username" type="text" name="username" onChange={onChange} value={user.username} className="input" />
          </div>

          <div className="input_wrap input_wrap2">
            <label htmlFor="password">비밀번호</label>
            <input id="password" type="password" name="password" onChange={onChange} value={user.password} className="input" />
          </div>

          <div className="save_btn">
            <label htmlFor="idSave" className="checkbox_wrap">이메일 저장
              <input id="idSave" name="idSave" type="checkbox" onChange={toggleChecked} checked={idSave} />
              <span className="checkmark"></span>
            </label>
          </div>

          <button type="submit" label="Log in" className={user.username !== '' && user.password !== '' && 'btn_active'}>로그인</button>
          <Link to={`/signup/?redirect=${redirect}`}>
            <div className="join_btn">
              회원가입
            </div>
          </Link>

          <ul className="find_btn">
            {/* <li>이메일 찾기</li>
            <li className="line"></li> */}
            <li><Link to={'/forgot'}>비밀번호 찾기</Link></li>
          </ul>
        </form>
      </div>
    )
  }
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

export default LoginForm



// WEBPACK FOOTER //
// ./Src/Components/User/LoginForm.js